import { ESdChangeReason, IProperty } from "@kuika/kuika-cl-model";
import { withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { PropertyHelper } from "../../../../shared/utility/property-helper";
import KuikaCollapsePanel from "../../../ui-kit/kuika-collapse-panel/kuika-collapse-panel";

/** The section's one panel. */
const PROPERTY_PANEL_KEY: string = "1";

export interface IPropertyPanelState {}

export interface IPropertyPanelProps {
  property: IProperty;
  location: "NavigationPanel" | "PropertyPanel";
  children: any;
  isExpandedPanel: boolean;
  onChangeExpandedPanel: (isExpandedPanel: boolean) => void;
}

class PropertyPanel extends PureSdComponent<IPropertyPanelProps & IWithContextProp, IPropertyPanelState> {
  propertyHelper: PropertyHelper;

  constructor(props: IPropertyPanelProps & IWithContextProp) {
    super(props);
    this.propertyHelper = new PropertyHelper();
  }

  changeCollapse = () => {
    if (this.props.onChangeExpandedPanel !== undefined) {
      this.props.onChangeExpandedPanel(this.props.isExpandedPanel !== true);
    }
  };

  // The body is dropped on close (destroyInactivePanel), so a property's editor is built afresh
  // on every open, as it was under antd.
  render() {
    return this.props.location === "PropertyPanel" &&
      this.propertyHelper.isResponsiveColInput(this.props.property) !== true ? (
      <KuikaCollapsePanel
        destroyInactivePanel
        iconPlacement="right"
        className="kuika-right-panel__collapse kuika-right-panel__collapse--property"
        onChange={this.changeCollapse}
        activeKey={this.props.isExpandedPanel === true ? PROPERTY_PANEL_KEY : ""}
        items={[
          {
            key: PROPERTY_PANEL_KEY,
            label: (
              <div
                data-testid={this.props.property.name + "Property"}
                className={`kuika_propertyFormComp_propertyName property-panel-header-${this.propertyHelper
                  .getPropertyName(this.props.property)
                  .replace(/\s/g, "")
                  .toLowerCase()}`}
              >
                {this.propertyHelper.getPropertyName(this.props.property)}
              </div>
            ),
            children: (
              <div className="kuika-right-panel__collapse-body kuika-right-panel__collapse-body--property">
                {this.props.children}
              </div>
            )
          }
        ]}
      />
    ) : (
      <>
        {this.props.location === "NavigationPanel" && (
          <span style={{ marginLeft: 10, marginBottom: 4 }}>
            {this.propertyHelper.getPropertyName(this.props.property)}
          </span>
        )}
        {this.props.children}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.UpdateVisibilty ||
      changeReason === ESdChangeReason.ChangePropertyType ||
      changeReason === ESdChangeReason.ChangedCustomFieldOnPropertyPanel ||
      changeReason === ESdChangeReason.ExpandedProperties ||
      changeReason === ESdChangeReason.ChangeResponsiveRowColumnSettings ||
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock
    ) {
      return true;
    }
    return false;
  };
}

const propertyPanel = withContext<IPropertyPanelProps>(withSD<IPropertyPanelProps>(PropertyPanel));
export { propertyPanel as PropertyPanel };
